module.exports = __webpack_public_path__ + "static/media/survey_finished_icon.627509c0.svg";